leftTree